import { NetworkStatus } from '@cbridge-utils/network';
import { IMarkupProfile } from '@cbridge-packages/markup-profile';
import { ISymbol } from '@cbridge-packages/symbol';
import { IStreamBase } from '@cbridge-packages/stream';
import { INode } from '@cbridge-packages/node';
import { ISpreadProfile } from '@cbridge-packages/spread-profile';

export enum MarkupColumns {
  Name = 'coreSymbolName',
  Bid = 'bidMarkup',
  Ask = 'askMarkup',
  Type = 'type',
  SpreadProfile = 'spreadProfileName',
  TobMinSpread = 'tobMinSpread',
  TobMaxSpread = 'tobMaxSpread',
}

export interface IStreamAssignedToMarkup extends IStreamBase {
  nodeId: INode['nodeId'];
}

export interface IMarkup {
  symbolId: ISymbol['symbolId'];
  coreSymbolName: ISymbol['name'];
  askMarkup: number;
  bidMarkup: number;
  type: MarkupType;
  spreadProfileName?: string;
  tobMinSpread?: number | null;
  tobMaxSpread?: number | null;
}

export interface IMarkupDetails {
  symbolId: ISymbol['symbolId'];
  coreSymbolName: ISymbol['name'];
  askMarkup: number;
  bidMarkup: number;
  type: MarkupType;
  streams?: IStreamAssignedToMarkup[];
  spreadProfile?: ISpreadProfile;
}

export enum MarkupType {
  Points = 'points',
}

export interface IMarkupSymbolKey {
  profileId: IMarkupProfile['markupProfileId'];
  coreSymbolId: ISymbol['symbolId'];
}

export interface IMarkupFilter {
  limit?: number;
  skip?: number;
  search?: string;
  symbolGroup?: string;
  sort?: string[];
}

export interface IMarkupListKey extends IMarkupFilter {
  profileId: IMarkupProfile['markupProfileId'];
}

export interface IMarkupStoreData extends IMarkupDetails {
  networkStatus?: NetworkStatus;
}

export interface IMarkupStore {
  data: Record<IMarkupDetails['symbolId'], IMarkupStoreData>;
  filteredCount: number;
  totalCount: number;
  networkStatus: NetworkStatus;
}

export interface IMarkupStoreSegment {
  markup: IMarkupStore;
}
